import { ExpressFormMenuKey } from "@/pages/ExpressForm/express-data";
import { AccountNextStep } from "./Account";
import { NotifierRoles } from "./Person";

export type FormMenuEntry = { key: string; label: string; done?: boolean; error?: boolean };
export type ExpressFormMenuEntry = {
  key: ExpressFormMenuKey;
  label: string;
  done?: boolean;
  error?: boolean;
};
export interface DisplayOptions<T> {
  value: T;
  label: string;
}
export interface UIQuilterState {
  isQuilter: boolean;
  quilterThresholdReached: boolean;
  [AccountNextStep.WithdrawalOfFundsToExecutorAccount]: boolean;
  isPlaceOfDeathUk: boolean;
}
export const NEQuilterInitialState: UIQuilterState = {
  isQuilter: false,
  quilterThresholdReached: false,
  [AccountNextStep.WithdrawalOfFundsToExecutorAccount]: false,
  isPlaceOfDeathUk: true,
};

export interface NEUiInfo {
  willExists: boolean;
  collectNokDetails: boolean;
  collectExecutorDetails: boolean;
  intestacyFlow: boolean;
  bypassKYC: boolean;
  notifierRole: NotifierRoles | null | undefined;
  quilter: UIQuilterState;
  spsRequireGOR: boolean;
  refresh: number;
  thirdPartyMarketing: boolean;
}

export const NEUiInfoInitialState: NEUiInfo = {
  willExists: false,
  collectNokDetails: false,
  collectExecutorDetails: false,
  intestacyFlow: false,
  bypassKYC: false,
  notifierRole: null,
  quilter: NEQuilterInitialState,
  spsRequireGOR: false,
  refresh: 0,
  thirdPartyMarketing: false,
};

export interface ExpressUiInfo {
  willExists: boolean;
  collectNokDetails: boolean;
  collectExecutorDetails: boolean;
  quilter: UIQuilterState;
  notifierRole: NotifierRoles | null | undefined;
}

export const ExpressUiInfoInitialState: ExpressUiInfo = {
  willExists: false,
  collectNokDetails: false,
  collectExecutorDetails: false,
  quilter: NEQuilterInitialState,
  notifierRole: null,
};
